import React, { forwardRef } from "react";
import { cn } from "../../utils/cn";

export const Textarea = forwardRef(
  ({ className, error, rows = 3, autoResize, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          "w-full px-3.5 py-2.5 rounded-xl border bg-slate-900/60 text-white placeholder-slate-500 transition-all duration-200 outline-none text-sm resize-y",
          "focus:border-urb-primary focus:ring-1 focus:ring-urb-primary focus:bg-slate-900/90",
          error
            ? "border-red-500/80 focus:border-red-500 focus:ring-red-500/40"
            : "border-slate-800 hover:border-slate-700",
          props.disabled && "opacity-50 cursor-not-allowed bg-slate-950",
          className
        )}
        {...props}
      />
    );
  }
);

Textarea.displayName = "Textarea";
export const InputTextarea = Textarea;
export default Textarea;
